<template>
  <v-app>
    <v-main>
      <v-container class="d-flex align-center justify-center" style="height: 100vh;">
        <v-card class="pa-5" style="width: 500px;">
          <v-card-title class="text-h5">登入打卡系統</v-card-title>
          <v-form @submit.prevent="login">
            <v-card-text>
              <!-- 帳號輸入 -->
              <v-text-field v-model="info.account" label="帳號" prepend-icon="mdi-account" outlined full-width
                @keyup.enter="login"></v-text-field>

              <!-- 密碼輸入 -->
              <v-text-field v-model="info.password" label="密碼" prepend-icon="mdi-lock" type="password" outlined
                full-width @keyup.enter="login"></v-text-field>
            </v-card-text>

            <!-- 登入按鈕 -->
            <v-card-actions class="d-flex justify-center">
              <v-btn color="primary" @click="login" variant="tonal" style="margin-right: 20px;">登入</v-btn>
              <div>
                <!-- 忘記密碼按鈕 -->
                <v-btn color="primary" @click="showAlert" variant="tonal">忘記密碼</v-btn>
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/config';

export default {
  data() {
    return {
      info: {
        account: '',
        password: '',
      },
      mailAccount: '',
      identity: '',
      dialog: false,  // 控制對話框顯示
      emailRule: (v) => !!v || '信箱為必填項'  // 驗證信箱是否有輸入
    }
  },

  methods: {
    login() {
      if (this.info.account && this.info.password) {
        axios.post(`${BASE_URL}/checkLogin`, this.info)
          .then(response => {
            // 檢查是否有錯誤訊息
            if (!response.data.success) {
              // 從後端獲取錯誤訊息
              const errorMsgs = response.data.errorMsgs;
              if (errorMsgs) {
                // 顯示具體的錯誤訊息
                if (errorMsgs.account) {
                  alert(errorMsgs.account); // 顯示帳號相關錯誤
                  return;
                }
                if (errorMsgs.password) {
                  alert(errorMsgs.password); // 顯示密碼相關錯誤
                  return;
                }
              }
              return;
            }

            // 成功登入的處理
            const token = response.data.data.token;
            const roleId = response.data.data.roleId;

            if (token && roleId) {
              if (roleId == 3) {
                alert('帳號已被停權');
                return;
              }

              // 儲存登入資訊，包含帳號
              this.$store.dispatch('saveLoginData', {
                token,
                roleId,
                account: this.info.account
              })
                .then(() => {
                  this.$router.push('/check');
                });
            } else {
              alert('登入失敗：系統錯誤');
            }
          })
          .catch(error => {
            // 處理後端返回的錯誤訊息
            if (error.response && error.response.data) {
              const errorData = error.response.data;
              if (errorData.errorMsgs) {
                // 顯示具體的錯誤訊息
                const errorMsgs = errorData.errorMsgs;
                if (errorMsgs.account) {
                  alert(errorMsgs.account);
                } else if (errorMsgs.password) {
                  alert(errorMsgs.password);
                }
              } else {
                alert('登入失敗：' + (errorData.message || '請稍後再試'));
              }
            } else {
              // 如果是網路錯誤或其他未知錯誤
              alert('登入失敗：網路異常，請稍後再試');
            }
            console.error('登入錯誤:', error);
          });
      } else {
        alert('請輸入帳號和密碼');
      }
    },
    showAlert() {
      alert("請通知主管重置密碼");
    },
    submitEmail() {
      let errorMessage = '';

      // 檢查信箱是否輸入
      if (!this.mailAccount) {
        errorMessage += '請輸入有效的信箱。\n';
      }

      // 檢查身份證字號是否輸入
      if (!this.identity) {
        errorMessage += '請輸入身份證字號。\n';
      }

      // 如果有錯誤訊息，顯示錯誤訊息
      if (errorMessage) {
        alert(errorMessage);
      } else {
        // 如果輸入有效，執行忘記密碼的邏輯
        this.forgetPassword();  // 呼叫忘記密碼的邏輯
        this.dialog = false;    // 關閉對話框
      }
    },

    forgetPassword() {
      const requestData = {
        mailAccount: this.mailAccount,  // 使用正確的 v-model 綁定值
        identity: this.identity,        // 使用正確的 v-model 綁定值
      };

      axios.post(`${BASE_URL}/forgetPassword`, requestData)
        .then(response => {
          if (response.data.success) {
            alert('重設密碼的郵件已發送到您的郵箱');
            this.mailAccount = '';  // 清空輸入欄
            this.identity = '';     // 清空輸入欄
          } else {
            alert('請求失敗，請重試');
          }
        })
        .catch(error => {
          // 檢查是否有具體的錯誤訊息
          if (error.response && error.response.data && error.response.data.errorMsgs) {
            const errorMsgs = error.response.data.errorMsgs;
            let allErrors = '';

            if (errorMsgs.mailAccount) {
              allErrors += '錯誤: ' + errorMsgs.mailAccount + '\n';
            }
            if (errorMsgs.identity) {
              allErrors += '錯誤: ' + errorMsgs.identity + '\n';
            }
            if (errorMsgs.birthday) {
              allErrors += '錯誤: ' + errorMsgs.birthday + '\n';
            }

            // 一次性顯示所有錯誤訊息
            alert(allErrors.trim());
            this.resetForgetForm();
          } else {
            console.error('發生錯誤:', error);
            alert('請求失敗，請稍後再試');
          }
        });
    },
    resetForgetForm() {
      this.dialog = false;
      this.mailAccount = "";
      this.identity = "";
    },
  },
  mounted() {
    // 在頁面載入時初始化加密資料
    this.$store.dispatch('initializeStore').then(() => {
      // 檢查 store 中是否有 token
      const token = this.$store.state.token;
      if (token && token.length > 10) {
        this.$router.push('/check');
      }
    });
  }

};
</script>

<style scoped>
/* Optional: 控制卡片和畫面居中 */
.v-main {
  background-image: url('@/image/bk16.png');
  /* 設置背景圖片 */
  background-size: cover;
  /* 背景圖片覆蓋整個區域 */
  background-position: center;
  /* 圖片置中 */
  height: 100vh;
  /* 高度設置為視窗高度 */
}
</style>
